import { Table } from "@/features/Table";
import {
  type TimeSerieFileDate,
  time_serie_file_dates_columns,
} from "./columns";
import {
  type FilterTimeSerieFileDateSchema,
  FilterTimeSerieFileDate,
} from "./filter";

const client = "instit-quantilia";
const table_name = "time_serie_file_dates";

export const TimeSerieFileDatesTable = () => {
  return (
    <Table<TimeSerieFileDate, FilterTimeSerieFileDateSchema>
      label="Time Series File Dates"
      client={client}
      table_name={table_name}
      columns={time_serie_file_dates_columns}
      filter={<FilterTimeSerieFileDate />}
      disable_translations_request={true}
    />
  );
};
